import generateApiEndpoint from '@/helpers/generateApiEndpoint';
import { DEFAULT_HEADERS } from './constants.service';
import http from './http';


export const getPlans = () => {
  return http.get(import.meta.env.VITE_APP_BASE_API + 'tiers/all', {
    headers: DEFAULT_HEADERS
  });
};

export const getTiers = () => {
  return http.get(import.meta.env.VITE_APP_BASE_API + 'tiers/info', {
    headers: {
      'Content-Type': 'application/json'
    }
  });
}

export const getAddOns = () => {
  return http.get(import.meta.env.VITE_APP_BASE_API + 'tiers/add-ons', {
    headers: DEFAULT_HEADERS
  });
}

export const getCheckoutSession = (id, campaign, old_to_new) => {
  return http.post(
    import.meta.env.VITE_APP_BASE_API + 'stripe/checkout_session',
    {},
    {
      params: {
        tier_id: id,
        campaign: campaign,
        old_to_new: old_to_new
      },
      headers: DEFAULT_HEADERS
    }
  );
};

export const getCheckoutSessionAddon = (id, quantity) => {

  return http.post(
    import.meta.env.VITE_APP_BASE_API + 'stripe/add_on_checkout_session',
    {},
    {
      params: {
        add_on_id: id,
        quantity
      },
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );
};

export const getCheckoutSessionExtraMessages = (id, campaign) => {
  return http.post(
    import.meta.env.VITE_APP_BASE_API + 'stripe/checkout_session_topup',
    {},
    {
      params: {
        add_on_id: id,
      },
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );
};

export const getCheckoutSessionCredits = (id) => {
  return http.post(
    import.meta.env.VITE_APP_BASE_API + 'stripe/checkout_session_topup',
    {},
    {
      params: {
        price_id: id
      },
      headers: DEFAULT_HEADERS
    }
  );
};


export const getCredits = () => {
  return http.get(import.meta.env.VITE_APP_BASE_API + 'topup', {
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

export const getDowngradeFeatures = (new_tier) => {
  return http.get(generateApiEndpoint('tiers/downgrade/features-lost-new'), {
    params: {

      new_tier
    },
    headers: DEFAULT_HEADERS
  });
};

export const sendDowngradeFeedback = ({ current_tier, new_tier, user_id, feedback }) => {

  return http.post(generateApiEndpoint('tiers/downgrade/feedback'), {}, {
    params: {
      current_tier,
      new_tier,
      user_id,
      feedback
    },
    headers: DEFAULT_HEADERS
  });
};

export const removeTeamMembers = ({ current_tier, new_tier, remove_user_ids, check }) => {
  return http.post(generateApiEndpoint('tiers/downgrade/team-management'), {
    current_tier,
    new_tier,
    remove_user_ids,
    check
  }, {

    headers: DEFAULT_HEADERS
  });
};

export const finishCancelDowngrade = () => {
  return http.post(generateApiEndpoint('stripe/cancel_trial'), {}, {
    headers: DEFAULT_HEADERS
  });
};

export const finishDowngrade = (tier_id) => {
  return http.post(generateApiEndpoint('stripe/checkout_session'), {}, {
    params: {
      tier_id
    },
    headers: DEFAULT_HEADERS
  });
};

export const getOnboardingTiers = () => {
  return http.get(import.meta.env.VITE_APP_BASE_API + 'tiers/onboarding-tiers', {
    headers: {
      'Content-Type': 'application/json'
    }
  });
}

export const applyDiscountOffer = (user_id) => {
  return http.post(generateApiEndpoint(`tiers/discount?user_id=${user_id}`), {}, {
    headers: DEFAULT_HEADERS
  });
};

export const getPromotionalCheckout = () => {
  return http.post(import.meta.env.VITE_APP_BASE_API + 'stripe/promotional_checkout', {}, {
    headers: DEFAULT_HEADERS
  });
};


export const getDowngradeInsights = () => {
  return http.get(import.meta.env.VITE_APP_BASE_API + 'tiers/downgrade/insights', {
    headers: DEFAULT_HEADERS
  });
};

export const saveDowngradeReason = (data) => {
  return http.post(
    import.meta.env.VITE_APP_BASE_API + 'tiers/downgrade/reason/' + data.tier_downgrade_reason_id,
    {},
    {
      params: { reason: data.reason },
      headers: DEFAULT_HEADERS
    }
  );
};

export const saveDowgradeBookMeeting = (data) => {
  return http.post(import.meta.env.VITE_APP_BASE_API + 'tiers/downgrade/book-meeting/' + data.tier_downgrade_reason_id, {} , {
    params: { button_clicked: true },
    headers: DEFAULT_HEADERS
  });
}

export const saveDowngradeStep = (data) => {
  return http.post(import.meta.env.VITE_APP_BASE_API + 'tiers/downgrade/reason/step/' + data.tier_downgrade_reason_id, {}, {
    params: { step: data.step },
    headers: DEFAULT_HEADERS
  });
}

export const submitFeedback = (data) => {
  return http.post(import.meta.env.VITE_APP_BASE_API + 'tiers/downgrade/user-feedback/' + data.tier_downgrade_reason_id, {}, {
    params: { answer_one: data.first_answer, answer_two: data.second_answer, answer_three: data.third_answer },
    headers: DEFAULT_HEADERS
  });
}

export const getNewUserCheckout = (campaign) => {
  return http.post(import.meta.env.VITE_APP_BASE_API + 'stripe/new_user_checkout', {}, {
    params: {
      campaign: campaign
    },
    headers: DEFAULT_HEADERS
  });
};


export const sendDowngradeEmail = (data) => {
  return http.post(import.meta.env.VITE_APP_BASE_API + 'tiers/downgrade/reason/send-email/' + data.tier_downgrade_reason_id, {}, {
    headers: DEFAULT_HEADERS
  });
}

export const saveChangedTier = (data) => {
  return http.post(import.meta.env.VITE_APP_BASE_API + 'tiers/downgrade/reason/tier-change/' + data.tier_downgrade_reason_id, {}, {
    params: { new_tier: data.new_tier, previous_tier: data.previous_tier },
    headers: DEFAULT_HEADERS
  });
}